import { PixNotification } from "../../master/pix/models/notification.model";

export class ListNotifications {
	notificationId: number;
	notificationList: boolean;
	notificationRead: boolean;
	messageTitle: any;
	messageContent: any;
	date: string;
	dateTime: Date;
	isPix: boolean;

	constructor() {

	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/shared/models/list-notifications.ts